'use client'

import { useEffect, useState } from 'react'

function formatTime(date: Date) {
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}

export default function SystemClock() {
  const [currentTime, setCurrentTime] = useState<Date>(() => new Date())

  useEffect(() => {
    const timer = window.setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => window.clearInterval(timer)
  }, [])

  return (
    <div className="hidden text-right sm:block">
      <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
        System Clock
      </div>
      <div className="font-mono text-xs text-cyan-600 dark:text-cyan-400">
        {formatTime(currentTime)}
      </div>
    </div>
  )
}